"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapIconInfo = exports.mapAnchorCoordinates = void 0;
const mapIconInfo = exports.mapIconInfo = {
  pin: {
    width: 42,
    height: 50
  },
  pinSelected: {
    width: 46,
    height: 55
  },
  cluster: {
    width: 48,
    height: 48
  },
  currentLocation: {
    width: 50,
    height: 50
  }
};
const mapAnchorCoordinates = exports.mapAnchorCoordinates = {
  pin: {
    x: 21,
    y: 45
  },
  pinSelected: {
    x: 23,
    y: 50
  },
  cluster: {
    x: 24,
    y: 24
  },
  currentLocation: {
    x: 25,
    y: 25
  }
};
